import React from 'react';

import GetImmigrationReviews from '@src/api/GetImmigrationReviews';
import { generateReview } from '@src/factories';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useFlatList from '@src/hooks/useFlatList';
import { Review } from '@src/types';

const useImmigrationBookReviews = (id: string) => {
  const axiosRequestConfig = useAxiosRequestConfig();

  const makeRequest = React.useCallback(
    async (offset: number, limit: number): Promise<Review[]> => {
      const response = await GetImmigrationReviews(
        id,
        offset,
        limit,
        axiosRequestConfig
      );
      const reviews: Review[] = [];
      for (const review of response.data?.reviews || []) {
        reviews.push(generateReview(review));
      }
      if (response.data?.review) {
        reviews.push(generateReview(response.data.review));
      }
      return reviews;
    },
    [axiosRequestConfig, id]
  );

  const flat = useFlatList(makeRequest);

  return React.useMemo(() => ({ ...flat }), [flat]);
};

export default useImmigrationBookReviews;
